import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaDropDown, { DropDownItem } from "../../BriaDropDown/BriaDropDown";
import styles from "./CodeExamplesDropdown.module.scss";

export type ExampleType = "regenerate" | "generate" | "refine";

const CodeExamplesDropdown = ({
	selectedExample,
	setSelectedExample,
}: {
	selectedExample: ExampleType;
	setSelectedExample: (example: ExampleType) => void;
}) => {
	const { t } = useTranslation("fibo", { keyPrefix: "apiReference.codeExamples" });

	const customExampleItem = (example: ExampleType) => {
		return (
			<Box className={styles.dropdownItem}>
				<Box className={styles.dropdownValueContainer}>
					<Typography className={styles.dropdownValue}>{t(example)}</Typography>
				</Box>
			</Box>
		);
	};
	const exampleTypes: DropDownItem<ExampleType>[] = [
		{
			key: "generate",
			value: "generate",
			customItem: customExampleItem("generate"),
			customSelectedKey: customExampleItem("generate"),
		},
		{
			key: "regenerate",
			value: "regenerate",
			customItem: customExampleItem("regenerate"),
			customSelectedKey: customExampleItem("regenerate"),
		},
		{
			key: "refine",
			value: "refine",
			customItem: customExampleItem("refine"),
			customSelectedKey: customExampleItem("refine"),
		},
	];
	return (
		<BriaDropDown<ExampleType>
			fullWidth
			items={exampleTypes}
			value={selectedExample}
			onChange={(e) => setSelectedExample(e.target.value as ExampleType)}
			placeholder="Select example type"
			width="100%"
			componentsProps={{
				root: { className: styles.dropdownButton },
			}}
		/>
	);
};

export default observer(CodeExamplesDropdown);
